<div class="profile-menu">
  <div class="btn-group" role="group">
    <app-profile-selector />
  </div>
  <div class="pt-3 pb-2">
    <ul class="profile-menu-items mb-3">
      <li
        class="menu-group-header"
        [class.active]="selectedMenu().startsWith('personalInfo')"
      >
        <div
          class="menu-item-header"
          (click)="toggleCollapse('personalInfo')"
          [attr.aria-expanded]="!isPersonalInfoCollapsed()"
          aria-controls="personalInfoCollapse"
        >
          <span class="title">{{ "profile.data.title" | translate }}</span>
          <i
            class="fas {{
              isPersonalInfoCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'
            }}"
          ></i>
        </div>
        <ul id="personalInfoCollapse" [ngbCollapse]="isPersonalInfoCollapsed()">
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'personalInfo.legalPerson'"
            (click)="selectMenu('personalInfo.legalPerson')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.data.legalPerson" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'personalInfo.representative'"
            (click)="selectMenu('personalInfo.representative')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.data.representative" | translate
              }}</span>
            </div>
          </li>
          <!--li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'personalInfo.documents'"
            (click)="selectMenu('personalInfo.documents')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.data.documents" | translate
              }}</span>
            </div>
          </li-->
        </ul>
      </li>
      <li
        class="menu-group-header"
        [class.active]="selectedMenu().startsWith('myProjects')"
      >
        <div
          class="menu-item-header"
          (click)="toggleCollapse('myProjects')"
          [attr.aria-expanded]="!isMyProjectsCollapsed()"
          aria-controls="myProjectsCollapse"
        >
          <span class="title">{{
            "profile.myProjects.title" | translate
          }}</span>
          <i
            class="fas {{
              isMyProjectsCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'
            }}"
          ></i>
        </div>

        <ul id="myProjectsCollapse" [ngbCollapse]="isMyProjectsCollapsed()">
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'myProjects.fundraising'"
            (click)="selectMenu('myProjects.fundraising')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.myProjects.fundraising" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'myProjects.submitted'"
            (click)="selectMenu('myProjects.submitted')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.myProjects.submitted" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'myProjects.inPreparation'"
            (click)="selectMenu('myProjects.inPreparation')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.myProjects.inPreparation" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'myProjects.underReview'"
            (click)="selectMenu('myProjects.underReview')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.myProjects.underReview" | translate
              }}</span>
            </div>
          </li>
        </ul>
      </li>
      <li
        class="menu-group-header"
        [class.active]="selectedMenu().startsWith('investments')"
      >
        <div
          class="menu-item-header"
          (click)="toggleCollapse('investments')"
          [attr.aria-expanded]="!isInvestmentsCollapsed()"
          aria-controls="investmentsCollapse"
        >
          <span class="title">{{
            "profile.investments.title" | translate
          }}</span>
          <i
            class="fas {{
              isInvestmentsCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'
            }}"
          ></i>
        </div>

        <ul id="investmentsCollapse" [ngbCollapse]="isInvestmentsCollapsed()">
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'investments.accepted'"
            (click)="selectMenu('investments.accepted')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.investments.accepted" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'investments.pending'"
            (click)="selectMenu('investments.pending')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.investments.pending" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'investments.rejected'"
            (click)="selectMenu('investments.rejected')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.investments.rejected" | translate
              }}</span>
            </div>
          </li>
        </ul>
      </li>

      <li
        class="simple-menu-item {{
          selectedMenu() === 'watchedProjects' ? 'active' : ''
        }}"
        (click)="selectMenu('watchedProjects')"
      >
        <div class="menu-item-header">
          <span class="title">{{
            "profile.watchedProjects.title" | translate
          }}</span>
        </div>
      </li>

      <li
        class="simple-menu-item {{
          selectedMenu() === 'complaint' ? 'active' : ''
        }}"
        (click)="selectMenu('complaint')"
      >
        <div class="menu-item-header">
          <span class="title">{{ "profile.complaint" | translate }}</span>
        </div>
      </li>
      <li
        class="simple-menu-item {{
          selectedMenu() === 'message' ? 'active' : ''
        }}"
        (click)="selectMenu('message')"
      >
        <div class="menu-item-header">
          <span class="title">{{ "profile.message" | translate }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
<div class="profile-details">
  <div class="buttons-container">
    <div class="left-side-buttons">
      @if (authStore.isUserQualifiedInvestor()) {
        <button
          class="btn btn-light dropdown-trigger"
          type="button"
          [disabled]="isProfessionalClient()"
          (click)="onQualificationButtonClick()"
        >
          <div class="profile-selection-button-content">
            <span class="profile-selection-icon fas fa-star"></span>
            <div class="profile-selection-button-text">
              <span>{{ "profile.qualifiedInvestor" | translate }}</span>
            </div>
          </div>
        </button>
      } @else {
        <button
          class="btn btn-light dropdown-trigger"
          type="button"
          [disabled]="isProfessionalClient()"
          (click)="onQualificationButtonClick()"
        >
          <div class="profile-selection-button-content">
            <span class="profile-selection-icon fas fa-graduation-cap"></span>
            <div class="profile-selection-button-text">
              <span>{{ "profile.unQualifiedInvestor" | translate }}</span>
              <a>{{ "profile.reQualify" | translate }}</a>
            </div>
          </div>
        </button>
      }
    </div>
    <div class="right-side-buttons">
      <app-profile-projects-tab />
    </div>
  </div>
  <router-outlet />
</div>
